import { atomWithLocalStorage } from "./atom-with-storage";

export const sideBarAtom = atomWithLocalStorage("atom.sideBar", {
  expanded: true,
});
